/* ==========================================================================
   ModalOrigins > Client > Prototype
   ========================================================================== */

/* Prototype */
const prototype = {
    /* Add event listener */
    addEventListener: function addEventListener() {
        /* Origin List */
        this.origin.addEventListener();

        return this;
    },
    /* Remove event listener */
    removeEventListener: function removeEventListener() {
        /* Origin List */
        this.origin.removeEventListener();

        return this;
    }
};

/* Exports */
module.exports = prototype;
